import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export const FaqSection = () => {
  const faqs = [{
    q: '¿Cómo recibo el Master Kit después de comprar?',
    a: 'En menos de cinco minutos después del pago recibirás un correo electrónico con el enlace de descarga de los archivos PDF. Revisa que ingreses correctamente tu email al comprar. No se envía ningún producto físico y el acceso es de por vida.'
  }, {
    q: '¿Para quién está diseñado?',
    a: 'Está pensado para familias, cuidadores y profesionales de habla hispana que acompañan a adultos mayores. Las actividades se organizan por niveles para elegir propuestas acordes a las posibilidades de cada persona.'
  }, {
    q: '¿Necesito ser médico o enfermero para usarlo?',
    a: 'No. Las actividades generales están explicadas en lenguaje claro para familias y cuidadores. Vitalidad 360™ es un material educativo y de acompañamiento; no reemplaza la consulta, el diagnóstico, el tratamiento ni la rehabilitación indicados por profesionales de la salud.'
  }, {
    q: '¿Los 3 bonos están incluidos siempre?',
    a: 'Sí. Cocina Vital, Kit de Socialización y Checklist Hogar Seguro están incluidos con el Master Kit sin costo adicional.'
  }, {
    q: '¿Se puede usar junto con un cuidador externo o centro de día?',
    a: 'Sí. El material puede servir como apoyo para organizar actividades y registros cotidianos. Adáptalo a cada persona y a las pautas indicadas por sus profesionales de salud.'
  }, {
    q: '¿Puedo imprimirlo?',
    a: 'Sí. Es un material digital en PDF, con letra grande y legible. Puedes imprimirlo completo o por partes, o utilizarlo desde una tablet o computadora.'
  }, {
    q: '¿Qué lo diferencia de buscar actividades en internet?',
    a: 'No son ejercicios aislados. Vitalidad 360™ reúne actividades, rutinas, registros y orientaciones en un único sistema organizado por niveles, para reducir el tiempo de búsqueda y saber por dónde comenzar.'
  }, {
    q: '¿Qué son los niveles de adaptación?',
    a: 'El Nivel Inicial propone opciones para movilidad reducida o mayor acompañamiento; el Nivel Medio, actividades con apoyo o supervisión; y el Nivel Avanzado, propuestas para personas más independientes y activas. No son diagnósticos: elige y adapta según cada persona.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Tarjetas de crédito y débito. El pago es único; no existen mensualidades ni suscripciones.'
  }, {
    q: '¿Tiene garantía real?',
    a: '🛡️ Tienes 30 días de garantía. Si el material no es lo que esperabas, puedes solicitar la devolución según las condiciones de compra.'
  }, {
    q: '¿Está disponible en mi país?',
    a: 'Sí. Vitalidad 360™ es 100% digital y está disponible para cualquier país. Recibirás el acceso por correo electrónico.'
  }, {
    q: '¿En qué moneda se cobra?',
    a: 'El precio se muestra en dólares estadounidenses (USD). Tu banco o emisor de la tarjeta realiza la conversión a tu moneda local.'
  }, {
    q: '¿Reemplaza la atención profesional?',
    a: 'No. Vitalidad 360™ es un material educativo y de acompañamiento. No reemplaza la consulta, el diagnóstico, el tratamiento ni la rehabilitación indicados por profesionales de la salud. La Bitácora puede facilitar la comunicación durante las consultas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="bg-familia-section py-10 md:py-16 px-4 md:px-6" data-id="element-70">
      <div className="max-w-3xl mx-auto w-[92%] md:w-full" data-id="element-71">
        <h2 className="text-[22px] sm:text-3xl md:text-4xl font-display font-bold text-center mb-8 md:mb-12" data-id="element-72">
          ❓ PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-2 md:space-y-4" data-id="element-73">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`border rounded-xl overflow-hidden transition-all duration-300 ${isOpen ? 'border-familia-cyan bg-familia-card' : 'border-familia-cyan/25 bg-familia-bg'}`} data-id="element-74">
                <button onClick={() => setOpenIndex(isOpen ? null : i)} className="w-full px-4 md:px-6 py-3 md:py-5 text-left flex justify-between items-center gap-3" data-id="element-75">
                  <span className="font-bold text-[14px] sm:text-base" data-id="element-76">
                    {faq.q}
                  </span>
                  <span className={`text-familia-cyan text-2xl transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-45' : ''}`} data-id="element-77">
                    +
                  </span>
                </button>
                <AnimatePresence data-id="element-78">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} data-id="element-79">
                      <div className="px-4 md:px-6 pb-4 md:pb-6 pt-2 text-familia-gray text-[14px] sm:text-base leading-relaxed border-t border-white/10" data-id="element-80">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
};